import { AxiosResponse } from 'axios';

import {
  ICreateCardBlacklistRequest,
  ICreateCardBlacklistResponse,
  IDeleteCardBlacklistsFilters,
  IDeleteCardBlacklistsResponse,
  IGetCardBlackListByIdResponse,
  IGetCardBlacklistFilters,
  IGetCardBlacklistResponse,
  IUpdateCardBlacklistRequest,
  IUpdateCardBlacklistResponse,
} from 'models/http/card-blacklist';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { DataUploadModels, ModelsNames } from 'utils/enums/model-names';
import { prepareFiltersOfSelection, prepareQPFromFilters, serverAxios } from 'utils/http';
import DataUploadBaseHttp from './utils/data-upload.http';
import { IGetSimpleListFilters, IGetSimpleListResponse } from 'models/http/common';

class CardBlacklistHttp extends DataUploadBaseHttp {
  protected readonly route: DataUploadModels = ModelsNames.BlacklistCard;

  public async get(filters?: IGetCardBlacklistFilters, abortController?: AbortController): Promise<IGetCardBlacklistResponse> {
    const queryParams = prepareQPFromFilters(filters || {});

    return serverAxios
      .get(`/${this.route}/${queryParams.toString()}`, {
        timeout: HttpTimeoutPriority.Medium,
        signal: abortController?.signal,
      })
      .then((response: AxiosResponse<IGetCardBlacklistResponse>) => {
        return response.data;
      });
  }

  public async getSimple(_?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    return serverAxios
      .get(`/${this.route}/simple`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetCardBlackListByIdResponse> {
    return serverAxios
      .get(`/${this.route}/single/${id}`, {
        timeout: HttpTimeoutPriority.Medium,
        signal: abortController?.signal,
      })
      .then((response: AxiosResponse<IGetCardBlackListByIdResponse>) => {
        return response.data;
      });
  }

  public async create(cardBlacklist: ICreateCardBlacklistRequest): Promise<ICreateCardBlacklistResponse> {
    return serverAxios
      .post(`${this.route}`, cardBlacklist, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateCardBlacklistResponse>) => {
        return response.data;
      });
  }

  public async update(id: number, cardBlacklist: IUpdateCardBlacklistRequest): Promise<IUpdateCardBlacklistResponse> {
    return serverAxios
      .put(`/${this.route}/${id}`, cardBlacklist, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IUpdateCardBlacklistResponse>) => {
        return response.data;
      });
  }

  public async delete(ids: number[]): Promise<IDeleteCardBlacklistsResponse>;
  public async delete(filters: IDeleteCardBlacklistsFilters): Promise<IDeleteCardBlacklistsResponse>;
  public async delete(filters: number[] | IDeleteCardBlacklistsFilters): Promise<IDeleteCardBlacklistsResponse> {
    return serverAxios
      .delete(`/${this.route}`, {
        data: prepareFiltersOfSelection(filters),
        timeout: HttpTimeoutPriority.Low,
      })
      .then();
  }
}

export default CardBlacklistHttp;
